import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const WorkSection = () => {
  const [steps, setSteps] = useState([]);

    const [page, setPage] = useState([]);
    const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL
  
    useEffect(() => {
      fetch(`https://aprilone-178ea8362c0b.herokuapp.com/page/${pageSlug}`)
        .then((res) => res.json())
        .then((info) => setPage(info))
        .catch((error) => console.error("Error fetching banners:", error));
    }, []);
  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/worksec`)
      .then((res) => res.json())
      .then((info) => setSteps(info));
  }, []);

  return (
   

    <>
    
    <section className="step">
        <div className="step__wrapper">
          <div className="container">
            <h2 className="section-heading color-black">Simple 3-Step Process.</h2>
            <div className="row">
              {
                steps.map(a => a.pageSlug === page.pageSlug && 

                  <div className="col-lg-4">
                    <div className="step__box border m-3 p-3 rounded">
                      <div className="content">
                        <h3>{a.stepNumber}<span>{a.stepTitle}</span></h3>
                        <p className="paragraph dark">{a.stepDetails}</p>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WorkSection;
